<template>
  <sl-page class="lg" style="margin-bottom:0;">
    <Row :gutter="12">
      <Col span="24">
        <sl-label title="合同编号" :content="data.contractNo" />
      </Col>
      <Col span="24">
        <sl-label title="合同类型" :content="data.contractType" />
      </Col>
      <Col span="24">
        <sl-label title="甲方名称" :content="data.partyAName" />
      </Col>
      <Col span="24">
        <sl-label title="乙方名称" :content="data.partyBName" />
      </Col>
      <Col span="24">
        <sl-label title="文件名称" :content="data.name" />
      </Col>
      <Col span="24">
        <sl-label title="合同有效期" :content="data.expire" />
      </Col>
      <Col span="24">
        <sl-label title="合同年限" :content="data.expire" />
      </Col>
      <Col span="24">
        <sl-label title="到期时间" :content="data.expiredTimeText" />
      </Col>
      <Col span="24">
        <sl-label title="创建人" :content="data.creator" />
      </Col>
      <Col span="24">
        <sl-label title="创建时间" :content="data.createDatetimeText" />
      </Col>
    </Row>
  </sl-page>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      id: null,
      data:{

      }
    }
  },

  mounted() {},

  methods: {
    query() {
      if (this.id) {
        this.$request.contract(this.id).then(resp => {
          if( !resp.code ){
            this.data = this.$utils.conv(resp.data,{'createDatetime':'time' , 'expiredTime':'time'})
          }
        })
      }
    },

    init( id ){
      this.reset()
      this.id = id
      this.query()
    }, 

    reset(){
      this.data = {}
    },

    handleClose() {
      this.$emit('on-update')
    }
  }
}

</script>